<input type="file" name="name" id="{{name}}" class="inputfile form-control-file display-hidden"
  (change)="onFileSelect($event.target)" [accept]="accept" />
<label class="btn btn-raised {{ btnStyleClasses }} pull-right"
       (click)="openFileBrowser($event)">
       {{ buttonText }}
</label>